import { AptunoButton, Icon } from '@aptuno/aptuno-ui';
import styled from 'styled-components';

export const EstateApplicationLayoutGrid = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  max-width: 794px;
  margin: auto;
  margin-bottom: 100px;
`;

export const ContentBox = styled.div<{
  bgColor?: string;
  horizontalAlign?: string;
  verticalAlign?: string;
  margin?: string;
  padding?: string;
}>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  ${(props) =>
    props.bgColor &&
    `
    background-color: ${props.bgColor};
  `};
  ${(props) =>
    props.horizontalAlign &&
    `
    align-items: ${props.horizontalAlign};
  `};
  ${(props) =>
    props.verticalAlign &&
    `
    justify-items: ${props.verticalAlign};
  `};
  ${(props) =>
    props.margin &&
    `
    margin: ${props.margin};
  `};
  ${(props) =>
    props.padding &&
    `
    padding: ${props.padding};
  `};
`;

export const ProcessContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 24px 24px;
  padding: 6px;
  margin: auto;
  transition: 0.3s all ease;

  @media screen and (min-width: 1000px) {
    max-width: 1031px;
  }
`;

export const ActionsBarRoot = styled.div<{
  bgColor?: string;
  flexDirection?: string;
  border?: string;
  height?: string;
  margin?: string;
}>`
  background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.colors.bgNavbarPrimary)};
  height: ${(props) => (props.height ? props.height : '80px')};
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 794px;
  border-radius: 24px 24px 0 0;
  gap: 8px;
  min-height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
  left: 50%;
  transform: translateX(-50%);

  & button {
    max-width: 500px;
    margin: auto;
  }

  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.flexDirection && `flex-direction: ${props.flexDirection}`};
  ${(props) => props.border && `border: ${props.border}`};
`;

export const HeaderButton = styled(AptunoButton)`
  height: 44px!important;
  width: 44px;

  & svg {
    color: #6c757d;
  }
`;

export const TitleSection = styled.div`
  font-size: 30px;
  font-weight: 700;
  line-height: 34px;
  color: black;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-bottom: 32px;
`;
export const Blue = styled.span`
  color: #0055fb;
`;

export const TextBox = styled.div<{bgColor?: string}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  padding: 24px;
  color: black;
  border-radius: 25px;

  background-color: ${(props) => props.bgColor ? `${props.bgColor}` : '#ffffff'};
  & h2 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: black;
  }
  & strong {
    color: black;
  }
  & p {
    color: #6c757d;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 0;
`;
export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 16px;
  line-height: 24px;
`;

export const DocumentFields = styled(InputGroup)`
  flex-direction: row;
  width: 100%;
  gap: 1rem;
  align-items: center;
`;

export const SelectContainer = styled.div<{ width?: string; height?: string; invalid?: boolean }>`
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '48px')};
  & > div {
    width: 100%;
  }
  & .rfs-control-container {
    width: ${(props) => (props.width ? props.width : '100%')};
    height: ${(props) => (props.height ? props.height : '48px')};
    border: 1px solid ${(props) => props.theme.colors.borderGray};
    border-radius: 8px;
    background-color: ${(props) => props.theme.colors.bgSecondary};
    outline: none;
    color: #6c757d;
    font-size: 16px;
    line-height: 24px;

    :hover {
      border-color: ${(props) => props.theme.colors.bgBrand};
      cursor: pointer;
    }
  }
  & .rfs-menu-container {
    width: ${(props) => (props.width ? props.width : '100%')};
    border-radius: 0px 0px 8px 8px;
  }
  & .rfs-option {
    color: ${(props) => props.theme.colors.textGray};
  }

  ${(props) =>
    props.invalid &&
    `
    border-color: ${(props) => props.theme.colors.bgBrand};
    & .rfs-control-container {
      background-color: #FDEAEB !important;
      border-color: #FCD6D8 !important;
      outline: none !important;
    }  
  `};
`;

export const FlexIcon = styled.div<{ iconColor?: string; height?: string; width?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.height ? props.height : '100%')};
  width: ${(props) => (props.width ? props.width : '100%')};
  & svg {
    color: ${(props) => (props.iconColor ? props.iconColor : '#3CD278')};
  }
`;

export const TextSecondary = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.textGray};
  margin: 0;
  margin-top: -16px;
`;

export const ListItem = styled.div<{ iconColor?: string; verticalAlign?: string; horizontalAlign?: string }>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  color: #555a64;
  align-items: ${(props) => (props.verticalAlign ? props.verticalAlign : 'center')};
  justify-content: ${(props) => (props.horizontalAlign ? props.horizontalAlign : 'start')};

  & svg {
    color: ${(props) => (props.iconColor ? props.iconColor : '#3CD278')};
  }
`;

export const HeaderSection = styled.div<{
  bgColor?: string;
  horizontalAlign?: string;
  verticalAlign?: string;
  margin?: string;
  padding?: string;
  isMobile?: boolean;
}>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  height: 100%;
  ${(props) =>
    props.bgColor &&
    `
  background-color: ${props.bgColor};
`};
  ${(props) =>
    props.horizontalAlign &&
    `
  align-items: ${props.horizontalAlign};
`};
  ${(props) =>
    props.verticalAlign &&
    `
  justify-content: ${props.verticalAlign};
`};
  ${(props) =>
    props.margin &&
    `
  margin: ${props.margin};
`};
  ${(props) =>
    props.padding &&
    `
  padding: ${props.padding};
`};
`;

export const BigTitle = styled.h1<{ align?: string; color?: string; weight?: number; margin?: string }>`
  font-size: ${(props) => props.theme.typography.size.md4}px;
  line-height: ${(props) => props.theme.typography.lineHeight.lg1}px;
  font-weight: ${(props) => props.theme.typography.weight.black};
  width: 100%;
  text-align: center;
  ${(props) =>
    props.color &&
    `
    color: ${props.color}
  `};
  ${(props) =>
    props.weight &&
    `
    font-weight: ${props.weight}
  `};
  ${(props) =>
    props.margin &&
    `
    margin: ${props.margin}
  `};
  ${(props) =>
    props.align &&
    `
    text-align: ${props.align}
  `};
`;

export const TextNormal = styled.p<{ margin?: string; align?: string }>`
  font-size: ${(props) => props.theme.typography.size.sm2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.sm5}px;
  color: ${(props) => props.theme.colors.textGray};
  font-weight: ${(props) => props.theme.typography.weight.regular};
  ${(props) =>
    props.margin &&
    `
    margin: ${props.margin}
  `};
  ${(props) => props.align && `text-align: ${props.align}`};
`;

export const ImageWrapper = styled.div<{ margin?: string; height?: string; width?: string }>`
  width: ${(props) => (props.width ? props.width : '100%')};
  height: ${(props) => (props.height ? props.height : '100%')};
  margin: ${(props) => (props.margin ? props.margin : '0')};

  & img {
    width: 100%;
    height: auto;
  }
`;

export const TitleDescription = styled.p`
  font-size: ${(props) => props.theme.typography.size.sm3}px;
  line-height: ${(props) => props.theme.typography.lineHeight.md2}px;
  color: ${(props) => props.theme.colors.textGray};
  text-align: center;
`;
export const Subtitle = styled.h2`
  font-size: ${(props) => props.theme.typography.size.sm4}px;
  line-height: ${(props) => props.theme.typography.lineHeight.md3}px;
`;

export const HighlightedText = styled.span`
  font-size: ${(props) => props.theme.typography.size.sm2}px;
  line-height: ${(props) => props.theme.typography.lineHeight.sm5}px;
  font-weight: ${(props) => props.theme.typography.weight.bold};
  color: ${(props) => props.theme.colors.textSecondary};
`;

export const IconClose = styled(Icon)`
  color: #9b9b9b;
  margin-right: 16px;
  cursor: pointer;
`;

export const InputHint = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  max-width: 300px;
  width: 100%;
  padding: 8px 16px;
`;

export const Hint = styled.span`
  font-size: 12px;
`;
